import type { Nullable } from '@ricoh/ria.client.core/types/core/data.type';

import { isNotNull } from '@ricoh/ria.client.core/utils/data/object';

import type { FlatItemPrepareOptions } from './flat-item.type';

/** Flat Item Mapper. */
export const flatItemMapper = {
  /**
   * Prepare Flat Items.
   *
   * @template TItem Item type.
   * @param {string} flatItemStr Flat Item string.
   * @param {FlatItemPrepareOptions<TItem>} options Options.
   *
   * @returns {TItem[]} Prepared Flat Items.
   */
  prepare: <TItem extends string>(
    flatItemStr: Nullable<string>,
    { emptyItem, include = [], exclude = [], transform }: FlatItemPrepareOptions<TItem> = {},
  ): TItem[] => {
    if (!flatItemStr) {
      return [];
    }

    const items = flatItemStr.split(',').map((item) => item.trim());
    if (isNotNull(emptyItem) && items.includes(emptyItem)) {
      return [];
    }

    return items.reduce<TItem[]>((prev, item) => {
      if ((include.length === 0 || include.includes(item)) && !exclude.includes(item)) {
        prev.push(transform ? transform(item) : (item as TItem));
      }

      return prev;
    }, []);
  },
};
